// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Attachment previews must cover the shared navigation (z-index: 9999). */
.document-preview-overlay {
  z-index: 10001 !important;
}

.document-preview-overlay:not(.MuiModal-root),
.document-preview-overlay.quotation-dialog-scrim,
.document-preview-overlay > .MuiBackdrop-root {
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}
`, "",{"version":3,"sources":["webpack://./src/styles/documentPreview.css"],"names":[],"mappings":"AAAA,0EAA0E;AAC1E;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,0BAA0B;EAC1B,kCAAkC;AACpC","sourcesContent":["/* Attachment previews must cover the shared navigation (z-index: 9999). */\n.document-preview-overlay {\n  z-index: 10001 !important;\n}\n\n.document-preview-overlay:not(.MuiModal-root),\n.document-preview-overlay.quotation-dialog-scrim,\n.document-preview-overlay > .MuiBackdrop-root {\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
